(ns common.opensearch.numeric-ranges)

(def numeric-percentiles [5 25 50 75 95])

(def range-script-source
  (str "if (doc[params.field].size() == 0) return false; "
       "double v = doc[params.field].value; "
       "if (params.containsKey('from') && !(v > params.from)) return false; "
       "if (params.containsKey('to') && !(v <= params.to)) return false; "
       "return true;"))

(defn percentiles-aggregation
  [flat-field]
  {:percentiles {:field flat-field
                 :percents numeric-percentiles}})

(defn range-clause
  [flat-field {:keys [from to]}]
  (when (or (some? from)
            (some? to))
    {:script {:script {:lang "painless"
                       :source range-script-source
                       :params (cond-> {:field flat-field}
                                 (some? from)
                                 (assoc :from from)

                                 (some? to)
                                 (assoc :to to))}}}))
